import CartItem from '@/features/Checkout/components/Cart/CartItem'
import Icon from '@/components/Icon'
import { useTheme } from '@/lib/hooks'

import { DialogOverlay, ProductDialogWrapper, CloseButton } from './ProductDialog.styles'

const ProductDialog = ({ onClose }) => {
  const themes = useTheme()

  return (
    <DialogOverlay onClick={onClose}>
      <ProductDialogWrapper onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose}>
          <Icon name="close" />
        </CloseButton>
        {themes.products.map((product, index) => (
          <CartItem key={index} product={product} destination="add" onProductAdd={onClose} />
        ))}
      </ProductDialogWrapper>
    </DialogOverlay>
  )
}

export default ProductDialog
